<template>
	<page>
		<module>
			<module-tab title="基础配置">
					<c-form ref="baseForm">
						<c-form-item v-model="levelName" type="input" label="等级名称" name="level_name" required maxlength="4" word="最多4个字符"></c-form-item>
						<c-form-item label="所属级别" v-if="!id" type="select" name="level_sort" :options="levelOptions" required></c-form-item>
						<c-form-item v-else type="hidden" name="level_sort"></c-form-item>
						<c-form-item type="hidden" name="discount" value="100"></c-form-item>
						<c-form-item type="hidden" name="discount" value="100"></c-form-item>
                        <c-form-item v-model="levelBgImage" type="image" label="等级页面背景" name="level_bg_img" required button
                                     file-word="建议尺寸：640×280像素，格式支持：jpg、png">
                        </c-form-item>
                        <c-form-item v-model="cardImage" type="image" label="等级卡片背景" name="level_card_img" required button file-word="建议尺寸：640×280像素，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E5%8D%A1%E8%83%8C%E6%99%AF%E6%A8%A1%E6%9D%BF.psd'>下载模板</a>">
                            <c-button slot="button" color="gray" hollow @click="select('card')">选择背景</c-button>
						</c-form-item>
                        <c-form-item v-model="cardTextColor" type="color" label="等级卡片文字颜色" name="card_text_color" required></c-form-item>
                        <c-form-item v-model="levelImage" type="image" label="等级徽章" limit="1" name="level_icon" required button file-word="建议尺寸：240×64像素，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E5%BE%BD%E7%AB%A0.psd'>下载模板</a>">
							<c-button slot="button" color="gray" hollow @click="select('level')">选择徽章</c-button>
						</c-form-item>
						<c-form-item v-model="levelColor" type="color" label="徽章文字颜色" name="icon_text_color" required></c-form-item>
						<c-form-item type="number" label="成长值门槛" name="level_threshold" required word="成长值达到该分数后，即可成为该成长等级，享受响应权益"></c-form-item>
						<c-form-item type="textarea" label="备注" name="remark" maxlength="150"></c-form-item>

					</c-form>
			</module-tab>
			
			<module-tab title="权益配置">
				<c-form>
                    <c-form-item type="radio" label="权益展示方式" name="right_type" v-model="rightType"
                                 :options="rightTypeOptions" :value="2" word="" required></c-form-item>

                    <c-form title="系统权益" v-show="rightType == 1">
						<c-table v-model="systemRights" ref="systemRights" border height="auto" style="width: 1000px;">
							<c-table-column
								label="权益类型"
								name="system_right_name"
								width="100"
							></c-table-column>
							<c-table-column
								label="权益名称"
								width="150"
							>
								<template v-slot="{data}">
									<span style="color: #007FFF;">{{data.right_name}}</span>
								</template>
							</c-table-column>
							<c-table-column
								label="权益图标"
								width="80"
							>
								<template v-slot="{data}">
									<c-image class="rights-icon" :src="data.right_logo"></c-image>
								</template>
							</c-table-column>
							<c-table-column
								label="描述说明"
								width="300"
							>
								<template v-slot="{data}">
									<div class="ellipsis-2">{{data.right_content}}</div>
								</template>
							</c-table-column>
							<c-table-column
								label="是否启用"
								width="80"
							>
								<template v-slot="{data}">
									<c-switch :value="data.state == 1" text="启用,禁用" @change="state => data.state = state ? 1 : 2"></c-switch>
								</template>
							</c-table-column>
							<c-table-column
								type="button"
								label="操作"
								width="80"
							>
								<template v-slot="row">
									<c-table-button @click="editRights(1, row)">编辑</c-table-button>
								</template>
							</c-table-column>
						</c-table>
					</c-form  >
					<c-form title="自定义权益" v-show="rightType == 1">
						<c-table v-model="customRights" ref="customRights" border height="auto" style="width: 1000px;">
							<c-table-column
								label="权益名称"
								width="150"
							>
								<template v-slot="{data}">
									<span style="color: #007FFF;">{{data.right_name}}</span>
								</template>
							</c-table-column>
							<c-table-column
								label="权益图标"
								width="100"
							>
								<template v-slot="{data}">
									<c-image class="rights-icon" :src="data.right_logo"></c-image>
								</template>
							</c-table-column>
							<c-table-column
								label="描述说明"
								width="300"
							>
								<template v-slot="{data}">
									<div class="ellipsis-2">{{data.right_content}}</div>
								</template>
							</c-table-column>

                            <c-table-column
                                    type="sort"
                                    label="排序"
                                    name="sort_value"
                                    @sort="sortHandle"
                            >
                            </c-table-column>

							<c-table-column
								type="button"
								label="操作"
								width="110"
							>
								<template v-slot="row">
									<c-table-button @click="editRights(2, row)">编辑</c-table-button>
									<c-table-button @click="customRights.splice(row.index, 1)">删除</c-table-button>
								</template>
							</c-table-column>
						</c-table>
						<c-button style="margin-top: 10px;" @click="editRights(2)" power="b_user_growth_edit">添加权益</c-button>
					</c-form>
                    <c-form title="权益图片" v-show="rightType == 2">
                        <c-form-item v-model="rightImage" type="image" label="权益图片" name="right_img" required button
                                     file-word="建议尺寸：640×280像素，格式支持：jpg、png">
                        </c-form-item>
                    </c-form>
				</c-form>
			</module-tab>

			<template slot="button">
				<c-button power="b_user_growth_edit" size="m" @click="saveHandle()">提交保存</c-button>
			</template>
		</module>
		
		<c-dialog ref="cardImage" title="选择背景" width="870" height="500" @resolve="selectHandle('card')">
			<div class="card-img flex-wrap">
				<div v-for="(item, i) in cardImageList" :key="i" class="item" :class="{'z-crt': currentCardImage == item}" @click="currentCardImage = item">
					<c-image :src="item" :background="false"></c-image>
				</div>
			</div>
		</c-dialog>
		
		<c-dialog ref="levelImage" title="选择徽章" width="600" height="350" @resolve="selectHandle('level')">
			<div class="level-img flex-wrap">
				<div v-for="(item, i) in levelImageList" :key="i" class="item" :class="{'z-crt': currentLevelImage == item}" @click="currentLevelImage = item">
					<c-image :src="item" :background="false"></c-image>
				</div>
			</div>
		</c-dialog>
		
		<c-dialog ref="rightsIcon" title="选择图标" width="600" height="350" @resolve="selectHandle('rights')">
			<div class="rights-img flex-wrap">
				<div v-for="(item, i) in rightsIconList" :key="i" class="item" :class="{'z-crt': currentRightsIcon == item}" @click="currentRightsIcon = item">
					<c-image :src="item" :background="false"></c-image>
				</div>
			</div>
		</c-dialog>
		
		<c-dialog ref="rightsEdit" title="设置权益" width="1000" height="600" @resolve="editRightsHandle">
			<c-form ref="rightsForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="权益名称" required name="right_name" maxlength="15" placeholder="最多15个字符"></c-form-item>
				<c-form-item v-model="rightsIcon" type="image" label="权益图标" name="right_logo" required button file-word="建议尺寸：100×100像素的透明图片，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E6%9D%83%E7%9B%8A%E5%9B%BE%E6%A0%87.psd'>下载模板</a>">
					<c-button slot="button" color="gray" hollow @click="select('rights')">选择图标</c-button>
				</c-form-item>
				<c-form-item v-if="editRightsData && editRightsData.data && editRightsData.data.system_right_id == 7"  type="number"  decimal="1" :limit="[1,9999]"
                             label="成长值倍数" name="reward_multiple" required
                             word="会员生日当天下单，可获得X倍的积分"
                ></c-form-item>
				<c-form-item type="textarea" label="描述说明" name="right_content"></c-form-item>

				<c-form-item label="选择优惠券" v-if="editRightsData && editRightsData.data && editRightsData.data.system_right_id == 6" required>
					<m-operate>
						<c-button color="gray" hollow @click="$refs.couponSelector.open()">添加优惠券</c-button>
					</m-operate>
					<c-table ref="couponList" v-model="couponList" height="auto" :paging="false" border>
						<c-table-column
							label="优惠券名称"
							name="coupon_name"
							width="180"
						></c-table-column>
						
						<c-table-column
							label="优惠力度"
							name="detail"
							width="120"
						></c-table-column>
						
						<c-table-column
							label="适用范围"
							name="commodity_range"
							width="70"
						>
							<template v-slot="{data}">
								{{dict.couponRange[data.commodity_range]}}
							</template>
						</c-table-column>
						
						<c-table-column
							label="剩余可领"
							name="surplus"
							width="70"
						></c-table-column>
						
						<c-table-column
							required
							label="领取后有效期(天)"
							width="130"
						>
							<template v-slot="row">
								<c-input v-model="row.data.effective_days" type="number"></c-input>
							</template>
						
						</c-table-column>
						
						<c-table-column
							required
							label="每人限领"
							width="80"
						>
							<template v-slot="row">
								<c-input v-model="row.data.received_count" type="number"></c-input>
							</template>
						</c-table-column>
						
						<c-table-column
							label="券标签"
							width="80"
						>
							<template v-slot="row">
								<c-input v-model="row.data.coupon_tag" maxlength="5"></c-input>
							</template>
						</c-table-column>
						
						<c-table-column
							type="button"
							fixed="right"
							label="操作"
							width="70"
						>
							<template v-slot="row">
								<c-table-button @click="row.remove()">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
			</c-form>
		</c-dialog>
		
		<!--优惠券选择-->
		<coupon-selector ref="couponSelector" multiple @resolve="couponSelectHandle($event, 'couponList', 'id')"></coupon-selector>
    </page>
</template>

<script>
    import validate from '@/assets/script/validate.js'
    import {mapState} from "vuex";
	import couponSelector from '@/components/service/coupon_selector.vue'

    export default {
		name: 'edit_user_growth',

		components: {
            couponSelector
		},
		
		props: {
			id: String
		},

		data() {
			return {
				levelOptions: [],

                levelBgImage: '',
				cardImage: '',
				cardImageList: [],
				currentCardImage: '',
				cardColor: '',
				
				levelName: '',
				levelImage: '',
				levelImageList: [],
				currentLevelImage: '',
				levelColor: '',
                cardTextColor: '',

				systemRights: [],
				customRights: [],
				rightsIcon: '',
				rightsIconList: [],
				currentRightsIcon: '',
				
				editRightsData: {},
				couponList: [],
                rightType:1,    //等级权益展示方式  1：列表 2：图片
                rightTypeOptions:[
                    {name: '权益列表',value: 1},
                    {name: '权益图片',value: 2}
                ],
                rightImage:''       //权益图片
			}
		},
		
		watch: {
			id() {
				this.update();
			}
		},
		
		computed: {
            ...mapState(['systemConfig']),
			...mapState(['dict']),
			rightsList() {
				return this.systemRights.filter(item => item.state == 1).concat(this.customRights);
			},
		},
		
		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.request({
					url: '/growth_level/sort/list',
					success: data => {
						this.levelOptions = Array.from(data, item => {
							return {
								name: item.name,
								value: item.level_sort
							}
						});
					}
				})
				
				this.request({
					url: '/growth_level/params',
					success: data => {
						this.cardImageList = data.level_card_img;
						this.levelImageList = data.level_icon;
						this.rightsIconList = data.right_logo;
					}
				})
				
				if (!this.id) {
					this.request({
						url: '/growth_level/right/list',
						success: data => {
							this.systemRights = data;
						}
					})
				} else {
					this.request({
						url: '/growth_level/detail',
						data: {
							id: this.id
						},
						success: data => {
							data.level_info.discount = parseFloat((data.level_info.discount * 100).toFixed(2));
                            this.levelPrice = data.level_info.level_price||null
                            this.systemRights = data.sys_right_list;
                            this.customRights = data.custom_right_list;
                            this.presentProductList = data.presentProductList||[];
                            this.rightType = data.level_info.right_type||1;
                            this.rightImage = data.level_info.right_img;
                            this.$refs.baseForm.set(data.level_info);
                        }
					})
				}
			},
			
			select(type) {
				switch (type) {
				case 'card':
					this.currentCardImage = '';
					this.$refs.cardImage.open();
					break;
					
				case 'level':
					this.currentLevelImage = '';
					this.$refs.levelImage.open();
					break;
					
				case 'rights':
					this.currentRightsIcon = '';
					this.$refs.rightsIcon.open();
					break;
				}
			},
			
			selectHandle(type) {
				switch (type) {
				case 'card':
					this.cardImage = this.currentCardImage;
					break;
					
				case 'level':
					this.levelImage = this.currentLevelImage;
					break;
					
				case 'rights':
					this.rightsIcon = this.currentRightsIcon;
					break;
				}
			},
			
			editRights(type, row) {
				this.editRightsData = row;
				this.$refs.rightsForm.clear();
				this.couponList = [];
				if (row) {
					this.$refs.rightsForm.set(row.data);
					if(row.data.right_json){
						this.couponList = JSON.parse(row.data.right_json);
					}
				}
				this.$refs.rightsEdit.open();
			},
            //排序
            sortHandle(row, type, next) {
                next();
            },
			editRightsHandle(stop, next) {
				stop();
				let data = this.$refs.rightsForm.get();
				validate(data, {
					rule: {
						right_name: '请填写权益名称',
						right_logo: '请上传权益图标',
						reward_multiple: [{
							type: 'function',
							fun: () => {
								return !(this.editRightsData && this.editRightsData.data && this.editRightsData.data.system_right_id == 7) || !!data.reward_multiple;
							},
							word: '请填写成长值倍数'
						}],
						// coupon_list: [{
						// 	type: 'function',
						// 	fun: () => {
						// 		return !(this.editRightsData && this.editRightsData.data && this.editRightsData.data.system_right_id == 2) || !!this.couponList.length;
						// 	},
						// 	word: '请选择赠送优惠券'
						// }],
						coupon_config: [{
							type: 'function',
							fun: () => {
								if(this.editRightsData && this.editRightsData.data && this.editRightsData.data.system_right_id == 2){
									return !this.couponList.find(item => {
										return !item.effective_days || !item.received_count;
									});
								}else{
									return true;
								}
							},
							word: '请设置赠送优惠券有效期及限领张数'
						}],
					},
					success: () => {
						next();
						//优惠券
						if(this.editRightsData && this.editRightsData.data && this.editRightsData.data.system_right_id == 6){
							let rightJsonData = this.couponList;
							data.right_json = JSON.stringify(rightJsonData);
						//生日成长值翻倍
						} if(this.editRightsData && this.editRightsData.data && this.editRightsData.data.system_right_id == 7){
							let rightJsonData = {
								reward_multiple: data.reward_multiple
							};
							data.right_json = JSON.stringify(rightJsonData);
						}
						
						if (this.editRightsData) {
							this.editRightsData.update(data);
						} else {
							this.customRights.push(data);
						}
					}
				});
			},
			
			/**选择优惠券后回调***/
			couponSelectHandle(list, ref, key) {
				list = list.filter(item => {
					return !this[ref].find(row => {
						return row[key] == item[key];
					});
				});
				this[ref] = this[ref].concat(list);
			},

			saveHandle() {
				this.$refs.baseForm.submit({
					url: '/growth_level/edit',
					rule: {
						level_name: '请填写等级名称',
						level_sort: '请选择所属级别',
						 level_card_img: '请上传等级卡片背景',
						// card_text_color: '请选择卡片文字颜色',
						level_icon: '请上传等级徽章',
                        card_text_color: '等级卡片文字颜色',
						icon_text_color: '请选择徽章文字颜色',
                        level_threshold: '请填写对应等级所需成长值',
                        right_img: [{
                            type: 'function',
                            fun: () => {
                                if (this.rightType == 2 && !this.rightImage){
                                    return false;
                                }else {
                                    return true;
                                }
                            },
                            word: '请上传等级权益图片',
                        }]
					},
					dataFormatter: data => {
                        data.id = this.id;
						this.systemRights = this.systemRights.map(item => {
							if (!item.right_json) return item;
							
							try {
								let parsedData;
								// 判断是数组还是对象
								if (item.right_json.trim().startsWith('[')) {
									// 数组格式处理
									parsedData = JSON.parse(item.right_json);
									const filteredData = parsedData.map(obj => {
										return {
											id: obj.id,
											effective_days: obj.effective_days,
											received_count: obj.received_count,
											coupon_tag: obj.coupon_tag
										};
									});
									// 转换回JSON字符串
									item.right_json = JSON.stringify(filteredData);
								} else {
									// 对象格式处理（保持原样）
									item.right_json = item.right_json;
								}
							} catch (e) {
								console.error('JSON解析错误:', e);
							}
							return item;
						});
						data.sys_right_list = this.systemRights;
						data.custom_right_list = this.customRights;
                        data.right_type = this.rightType;
                        data.right_img = this.rightImage;
						return data;
					},
					success: () => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('growth_level_list.update');
						this.redirectTo('/growth_level_list');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.preview {
		z-index: 1;
		position: sticky;
		top: 70px;
		right: 24px;
		align-self: flex-start;
		width: 375px;
		min-width: 375px;
		min-height: 734px;
		border-radius: 30px;
		background: #242329;
		
		@media screen and (max-width: 1640px) {
			display: none;
		}
		
		&-title {
			height: 62px;
			line-height: 78px;
			font-size: 18px;
			text-align: center;
			color: #fff;
		}
		
		&-user {
			padding: 0 34px;
			
			&-icon {
				width: 50px;
				height: 50px;
				border-radius: 100%;
				margin-right: 12px;
				font-size: 26px;
				background: #F5F5F5;
			}
			
			&-name {
				font-size: 16px;
				color: #fff;
			}
			
			&-level {
				width: 100%;
				height: 22px;
				padding-left: 28px;
				margin-top: 6px;
				line-height: 22px;
				font-size: 12px;
				background-size: auto 100%;
				background-repeat: no-repeat;
			}
		}
		
		&-card {
			position: relative;
			width: 320px;
			height: 140px;
			border-radius: 20px;
			margin: 14px auto 22px;
			overflow: hidden;
			
			p {
				position: absolute;
				left: 26px;
				top: 46px;
				font-size: 24px;
				font-weight: bold;
			}
			
			span {
				position: absolute;
				left: 26px;
				top: 84px;
				font-size: 12px;
				opacity: .7;
			}
		}
		
		&-rights {
			width: 25%;
			height: 100px;
			
			&-title {
				margin-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #FBCDA9;
			}
			
			&-icon {
				width: 54px;
				height: 54px;
				border-radius: 100%;
				background: linear-gradient(-40deg, #F5B778, #FFEDD1);
			}
			
			p {
				margin-top: 9px;
				font-size: 13px;
				color: #FAE2BF;
			}
		}
	}
	
	.gifts {
		&-tips {
			margin-left: 20px;
			font-size: 13px;
			color: #999;
		}
	}
	
	.card-img {
		padding: 5px 20px 20px 5px;
		
		.item {
			box-sizing: border-box;
			width: 260px;
			height: 120px;
			border: 1px solid #fff;
			padding: 5px;
			margin-left: 15px;
			margin-top: 15px;
			cursor: pointer;
			
			&:hover,
			&.z-crt {
				border-color: #000;
			}
		}
	}
	
	.level-img {
		padding: 5px 20px 20px 5px;
		
		.item {
			box-sizing: border-box;
			width: 140px;
			height: 50px;
			border: 1px solid #fff;
			padding: 5px;
			margin-left: 15px;
			margin-top: 15px;
			cursor: pointer;
			
			&:hover,
			&.z-crt {
				border-color: #000;
			}
		}
	}
	
	.rights-img {
		padding: 10px 20px 20px 10px;
		
		.item {
			box-sizing: border-box;
			width: 70px;
			height: 70px;
			border: 1px solid #fff;
			padding: 5px;
			margin-left: 10px;
			margin-top: 10px;
			cursor: pointer;
			
			&:hover,
			&.z-crt {
				border-color: #000;
			}
		}
	}
	
	.rights {
		&-icon {
			width: 40px;
			height: 40px;
		}
	}
</style>